import Vue from 'vue';
import { apiPath } from '../constants';

const TwoStepVerification = Vue.resource(
  `${apiPath}/account/otp{/action}/`,
  {},
  {
    setup: {
      method: 'POST',
      params: { action: 'setup' },
    },
    enable: {
      method: 'POST',
      params: { action: 'enable' },
    },
    disable: {
      method: 'POST',
      params: { action: 'disable' },
    },
    getStatus: {
      method: 'get',
      params: { action: 'state' },
    },
  },
  {
    transformToCamelCase: true,
  },
);

export default TwoStepVerification;
